import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=4453298c"
var script = {}
import style0 from "./Support.vue?vue&type=style&index=0&id=4453298c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports